export const validMimeTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
export const MAX_RECEIPT_SIZE = 10 * 1024 * 1024; //10MB

// Sanitize filename by removing unsafe characters for S3 keys
// eslint-disable-next-line no-control-regex
const UNSAFE_CHARS = /[<>:"|?*\\/\x00-\x1f]/g;
const VALID_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.pdf'];

// The V2CreateReceiptUpload handler rejects storage keys it considers path
// traversal ("Invalid document path"). Surfaces as a GraphQL error message.
export const isInvalidDocumentPathError = (error: unknown): boolean =>
  error instanceof Error && error.message.includes('Invalid document path');

export const sanitizeFileName = (fileName: string): string => {
  if (!fileName) return 'receipt';

  const dotIndex = fileName.lastIndexOf('.');
  let ext = dotIndex > 0 ? fileName.slice(dotIndex).toLowerCase() : '';
  let name = ext ? fileName.slice(0, dotIndex) : fileName;

  if (ext && !VALID_EXTENSIONS.includes(ext)) ext = '';

  // SEE-1457: the upload handler rejects any key containing ".." as path
  // traversal. A stem ending in a dot ("Elite 100.70." + ".pdf") or holding a
  // run of dots produced exactly that, so collapse dot runs and trim dots from
  // both ends of the stem. Inner single dots ("100.70") are fine.
  name = name
    .replace(UNSAFE_CHARS, '_')
    .replace(/_+/g, '_')
    .replace(/\.{2,}/g, '.')
    .replace(/^[.\s]+/, '')
    .replace(/[.\s]+$/, '')
    .trim();

  if (!name) return `receipt${ext}`;
  return `${name}${ext}`;
};
